import Box from "@mui/material/Box/Box";
import {Button, DialogActions, DialogContent, InputAdornment, TextField} from "@mui/material";
import {theme} from "../../../../../_fri/themes/theme";
import {LineOrIcon} from "../../../../../_fri/icons/LineOrIcon";
import {SubmitHandler, useForm, useWatch} from "react-hook-form";
import {ISearchUser, schemaSearchUser} from "../../core/_models";
import {yupResolver} from "@hookform/resolvers/yup";
import {useSearchFriUserMutation, useSendPaymentMutation} from "../../../../../store/api/service/ecommerce";
import {getRTKErrorMessage} from "../../../../../_fri/utils/function";
import CustomAlertDanger from "../../../../../_fri/components/CustomAlert/CustomAlertDanger";
import useInformationHook from "../../../../../_fri/hooks/useInformationHook";
import {SearchUserRequest, SendPaymentRequest, Transaction} from "../../../../../store/api/interface/ecommerce";
import {useEffect} from "react";

export interface IModalFIndUserContext {
    close: () => void;
    openModalLoader: () => void;
    setTransaction: (value:Transaction)=> void,
    valuePayment:string
}

export const EcommerceDashboardModalFIndUserContext = ({close, openModalLoader,setTransaction,valuePayment }: IModalFIndUserContext) => {

    const info = useInformationHook();
    const form = useForm<ISearchUser>({
        resolver: yupResolver(schemaSearchUser),
        defaultValues: {phone: "", user: ""}
    });
    const {phone, user} = useWatch(form);
    const [searchUser, searchUserStatus] = useSearchFriUserMutation();
    const [createPayment, createPaymentStatus] = useSendPaymentMutation();

    const onSubmit: SubmitHandler<ISearchUser> = (value) => {
        const data: SearchUserRequest = {
            info: info,
            requestContent: {
                ...(phone === "" && {username: value.user}),
                ...(user === "" && {phoneNumber: value.phone})
            }
        };
        searchUser(data);
    };

    useEffect(() => {

        if (!searchUserStatus.isSuccess) return;

        const data: SendPaymentRequest = {
            info:info,
            requestContent:{
                friUsername: searchUserStatus.data.responseContent.user.username,
                amount: valuePayment,
                reference:"145",
                note:"Televisor Led, Estufa a gas"
            }
        }

        createPayment(data);
        searchUserStatus.reset();

    }, [searchUserStatus.isSuccess]);

    useEffect(() => {

        if(!createPaymentStatus.isSuccess) return;

        setTransaction(createPaymentStatus.data.responseContent.transaction);
        close();
        openModalLoader();

    }, [createPaymentStatus.isSuccess]);


    return (
        <form onSubmit={form.handleSubmit(onSubmit)}>
            <DialogContent sx={{marginTop: "1rem"}}>
                <Box sx={{marginBottom: "0.5rem"}}>
                    <label>
                        Número de teléfono:
                    </label>
                    <TextField
                        {...form.register("phone")}
                        fullWidth
                        disabled={user !== ""}
                    />
                </Box>
                <Box sx={{display: "flex", justifyContent: "center"}}>
                    <LineOrIcon/>
                </Box>
                <Box sx={{marginTop:"0.5rem"}}>
                    <label>
                        Usuario fri:
                    </label>
                    <TextField
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Box width={"1.5rem"} sx={{
                                        borderRight: `1px ${theme.palette.text.primary} solid`,
                                        color: theme.palette.text.primary
                                    }}>
                                        @
                                    </Box>
                                </InputAdornment>
                            )
                        }}
                        {...form.register("user")}
                        disabled={phone !== ""}
                        fullWidth
                    />
                </Box>
                <CustomAlertDanger text={getRTKErrorMessage(searchUserStatus.error)}
                                   show={searchUserStatus.isError}
                                   sx={{marginTop: "0.5rem"}}/>

                <CustomAlertDanger text={getRTKErrorMessage(createPaymentStatus.error)}
                                   show={createPaymentStatus.isError}
                                   sx={{marginTop: "0.5rem"}}/>

            </DialogContent>
            <DialogActions sx={{justifyContent: "center", marginBottom: "1rem"}}>


                <Box sx={{justifyContent: "center", display: "flex"}}>
                    <Button
                        sx={{
                            width: "6.5rem",
                            height: "3rem",
                            borderRadius: "0.5rem",
                        }}
                        color={"error"}
                        variant={"contained"}
                        onClick={close}
                        type={"button"}
                        disabled={createPaymentStatus.isLoading || searchUserStatus.isLoading}
                    >
                        Cancelar
                    </Button>
                </Box>

                <Box sx={{justifyContent: "center", display: "flex"}}>
                    <Button
                        sx={{
                            width: "6.5rem",
                            height: "3rem",
                            borderRadius: "0.5rem",
                        }}
                        color={"primary"}
                        variant={"contained"}
                        disabled={(phone === "" && user === "") || searchUserStatus.isLoading || createPaymentStatus.isLoading}
                        type={"submit"}
                    >
                        Crear
                    </Button>
                </Box>

            </DialogActions>

        </form>
    );
};